<template>
  <div class="check-banner-title">
    <img
      class="check-icon <tablet:hidden"
      src="@/assets/icon/checkbox-desktop.svg"
      alt="打勾"
    />
    <img
      class="check-icon tablet:hidden"
      src="@/assets/aboutUs/check-icon.svg"
      alt="打勾"
    />
    <h4 class="title text-left">
      {{ text1 }}
      <br class="tablet:hidden" />
      <img
        class="<tablet:hidden px-[10px]"
        src="@/assets/icon/star.svg"
        alt=""
      />
      {{ text2 }}
    </h4>
  </div>
</template>

<script setup>
defineProps({
  text1: {
    type: String,
    default: '',
  },
  text2: {
    type: String,
    default: '',
  },
})
</script>

<style scoped lang="postcss">
.check-banner-title {
  @apply relative bg-primary-100 text-white rounded-br-[20px] w-[fit-content] m-auto py-[9px] pl-[35px] pr-[24px];
  @apply tablet:(flex items-center  pl-[73px] pr-[59px]);
  @apply laptop:(flex items-center  pl-[93px] pr-[79px]);
}

.check-icon {
  @apply absolute left-[-27px] top-[-12px] h-[54px];
  @apply tablet:(w-[80px] h-[80px] top-[-15px]);
}

.title {
  @apply flex flex-col text-[20px] leading-[28.96px] tracking-[1px] font-bold;
  @apply tablet:(flex-row items-center text-[30px]);
}
</style>
